import type { Theme } from "../types";

export const GALAXY_LIGHT_COLOR: Theme["color"] = {
  text: {
    primary: "#101010",
    primaryAlt: "#ffffff",
    secondary: "#3f3f3f",
    secondaryAlt: "#acacac",
    tertiary: "#9e9e9e",
    tertiaryAlt: "#868686",
    success: "#4cb782",
    warning: "#e99243",
    error: "#e53f4f",
    pink: "#ff4595",
    orange: "#ff6b24",
    yellow: "#cbc24d",
    lime: "#9cca55",
    green: "#4cb782",
    blue: "#4885ff",
    teal: "#20b2a5",
    purple: "#b080f3",
    disabled: "#b8b8b8",
    galaxy: "#0059B8",
    galaxyAlt: "#0060c8",
  },
  background: {
    base: "#ffffff",
    baseAlt: "#131313",
    primary: "#fafafa",
    primaryAlt: "#161616",
    secondary: "#f0f0f0",
    secondaryAlt: "#242424",
    tertiary: "#f5f5f5",
    tertiaryAlt: "#202020",
    success: "#83d3b1",
    successAlt: "#1d3329",
    warning: "#2d1900",
    warningAlt: "#3f2e19",
    error: "#e6798c",
    errorAlt: "#3d1f24",
    pink: "#f8e6f7",
    pinkAlt: "#361c23",
    orange: "#ffe6d2",
    orangeAlt: "#3d2a12",
    yellow: "#faf8d2",
    yellowAlt: "#404022",
    lime: "#e4f8c5",
    limeAlt: "#263017",
    blue: "#e6f2ff",
    blueAlt: "#232f3b",
    teal: "#e6f7f9",
    tealAlt: "#2a393c",
    purple: "#f2f0ff",
    purpleAlt: "#272442",
    disabled: "#ffffff",
    disabledAlt: "#1e1e1e",
    galaxy: "#0059B8",
    galaxyAlt: "#0060c8",
  },
  border: {
    primary: "#cdcecd",
    secondary: "#d5d6d7",
    tertiary: "#e0e0e0",
    selected: "#d5d6d7",
    success: "#62c796",
    warning: "#968de1",
    error: "#e26178",
    disabled: "#e7e7e7",
    lime: "#9cca55",
    purple: "#b080f3",
    galaxy: "#0059B8",
    galaxyAlt: "#0060c8",
  },
  icon: {
    primary: "#101010",
    primaryAlt: "#ffffff",
    secondary: "#3f3f3f",
    secondaryAlt: "#acacac",
    tertiary: "#9e9e9e",
    tertiaryAlt: "#868686",
    success: "#4cb782",
    warning: "#e99243",
    error: "#e53f4f",
    pink: "#ff4595",
    orange: "#ff6b24",
    yellow: "#cbc24d",
    lime: "#966a55",
    blue: "#4885ff",
    teal: "#20b2a5",
    purple: "#b080f3",
    disabled: "#b8b8b8",
    galaxy: "#0059B8",
    galaxyAlt: "#0060c8",
  },
  opacity: {
    bw100: "rgba(255, 255, 255, 1)",
    bw100Alt: "rgba(0, 0, 0, 1)",
    bw80: "rgba(255, 255, 255, 0.8)",
    bw80Alt: "rgba(0, 0, 0, 0.8)",
    bw64: "rgba(255, 255, 255, 0.64)",
    bw64Alt: "rgba(0, 0, 0, 0.64)",
    bw48: "rgba(255, 255, 255, 0.48)",
    bw48Alt: "rgba(0, 0, 0, 0.48)",
    bw32: "rgba(255, 255, 255, 0.32)",
    bw32Alt: "rgba(0, 0, 0, 0.32)",
    bw24: "rgba(255, 255, 255, 0.24)",
    bw24Alt: "rgba(0, 0, 0, 0.24)",
    bw16: "rgba(255, 255, 255, 0.16)",
    bw16Alt: "rgba(0, 0, 0, 0.16)",
    bw12: "rgba(255, 255, 255, 0.12)",
    bw12Alt: "rgba(0, 0, 0, 0.12)",
    bw8: "rgba(255, 255, 255, 0.08)",
    bw8Alt: "rgba(0, 0, 0, 0.08)",
    b4: "rgba(255, 255, 255, 0.04)",
    b4Alt: "rgba(0, 0, 0, 0.04)",
    bw0: "rgba(255, 255, 255, 0)",
    bw0Alt: "rgba(0, 0, 0, 0)",
  },
};
